import { t } from './localization.js';

const mainElemCSSPath = '.top-panel_select-for-shopping-cart';
const stepsCSSPath = `${mainElemCSSPath} .top-panel__title-steps`;
const selectedTitleCSSPath = `${mainElemCSSPath} .top-panel__title-center .top-panel__menu-text`;
const selectedSubtitleCSSPath = `${mainElemCSSPath} .top-panel__title-center .top-panel__menu-subtext`;

const getTextForSteps = (amount, total) => t('home-step-label', { amount, total });
const getTextForSelect = (amount) => {
  if (Number.isFinite(amount)) {
    return t('home-select-up-to-images-title', { count: amount });
  }
  return t('home-select-as-many-images-title');
};
const getTextForTarget = (name) => t('home-select-target-label', { name });

export function initTopPanelSelectForShoppingCart() {
  return {
    setSteps,
    setSelectedImageTitle,
    setNameOfTarget,
  };

  function setSteps(amount, total) {
    if (total > 1) {
      const $elem = document.querySelector(stepsCSSPath);
      $elem.innerHTML = getTextForSteps(amount, total);
    }
  }

  function setSelectedImageTitle(amount) {
    const $elem = document.querySelector(selectedTitleCSSPath);
    $elem.innerHTML = getTextForSelect(amount);
  }

  function setNameOfTarget(name) {
    const $elem = document.querySelector(selectedSubtitleCSSPath);
    $elem.innerHTML = getTextForTarget(name);
  }
}
